import { Descriptions, Text } from '@/components';
import type { CSSProperties, ComponentProps, FC, ReactNode } from 'react';

const COLUMN = 3;

type Props = {
  width?: CSSProperties['width'];
  labelWidth?: CSSProperties['width'];
  items: Array<{ label: string; labelStyle?: CSSProperties; value: ReactNode }>;
  size?: ComponentProps<typeof Descriptions>['size'];
};
export const DetailsInfo: FC<Props> = ({
  width = 480,
  labelWidth,
  items,
  size,
}) => {
  return (
    <Descriptions
      labelStyle={{ width: labelWidth }}
      style={{ width, backgroundColor: 'white' }}
      bordered
      size={size}
      column={COLUMN}
    >
      {items.map((item, idx) => (
        <Descriptions.Item
          // biome-ignore lint/suspicious/noArrayIndexKey: biomeをCIに仕込むために暫定的にignore。keyにユニークな値を指定するか適切な理由に書き換えること
          key={idx}
          label={
            <Text
              text={item.label}
              weight="regular"
              style={{
                ...item.labelStyle,
                whiteSpace: 'nowrap',
                color: 'inherit',
              }}
            />
          }
          span={COLUMN}
        >
          {item.value}
        </Descriptions.Item>
      ))}
    </Descriptions>
  );
};
